import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        review: '='
    },
    template: `
        <review-default-finished ng-if="vm.finished" confirmed="vm.confirmed" declined="vm.declined"/>
        <div class="col00 small" ng-if="!vm.finished">
            <alert-error ng-if="vm.error">{{ vm.error }}</alert-error>
            <div ng-if="vm.answersSaved.show && !vm.review.isManageView" class="alert alert-notify" ng-bind-html="vm.answersSaved.text"></div>
            <div ng-if="vm.isFormDeadlinePassed()" class="alert alert-notify">
                {{ 'performanceReview.deadline for filling out the form has passed' | translate }}
            </div>
            <div class="well">
                <review-default-info
                    ng-if="vm.step===vm.REVIEW_STEP_ENUM.INFO || vm.review.isReadOnly"
                    review="vm.review"
                />
                <review-default-overview
                    ng-if="vm.step===vm.REVIEW_STEP_ENUM.OVERALL_OVERVIEW || vm.review.isReadOnly"
                    review="vm.review"
                />
                <review-default-results-and-goals
                    ng-if="vm.step===vm.REVIEW_STEP_ENUM.RESULTS_AND_GOALS || vm.review.isReadOnly"
                    review="vm.review"
                />
                <review-default-personal-development
                    ng-if="vm.step===vm.REVIEW_STEP_ENUM.PERSONAL_DEVELOPMENT || vm.review.isReadOnly"
                    review="vm.review"
                />
                <review-default-feedback
                    ng-if="vm.step===vm.REVIEW_STEP_ENUM.FEEDBACK || vm.review.isReadOnly"
                    review="vm.review"
                />
                <review-default-summary
                    ng-if="vm.step===vm.REVIEW_STEP_ENUM.SUMMARY || vm.review.isReadOnly"
                    review="vm.review"
                />
            </div>
            <div ng-if="vm.answersConfirmed.show" class="alert alert-warn" ng-bind-html="vm.answersConfirmed.text"></div>
            <ul class="actions01">
                <li class="primary" ng-if="vm.showNextButton()">
                    <a class="btn main" ng-click="vm.save()">{{ 'general.Next' | translate }}</a>
                </li>
                <li class="primary" ng-if="vm.showConfirmButton()">
                    <a class="btn main" ng-click="vm.confirm(true, vm.review)">{{ 'performanceReview.Confirm' | translate }}</a>
                </li>
                <li class="primary" ng-if="vm.showConfirmButton()">
                    <a class="btn negative" ng-click="vm.decline(vm.review)">{{ 'performanceReview.Decline' | translate }}</a>
                </li>
                <li class="primary" ng-if="vm.showSummaryStepButtons()">
                    <a class="btn main" ng-click="vm.confirm()">{{ 'performanceReview.Save and confirm' | translate }}</a>
                </li>
                <li class="primary" ng-if="vm.showSummaryStepButtons()">
                    <a class="btn bordered02" ng-click="vm.save()">{{ 'performanceReview.Continue later' | translate }}</a>
                </li>
                <li ng-if="vm.showBackButton()">
                    <a class="btn discrete" ng-click="vm.back()">{{ 'general.Back' | translate }}</a>
                </li>
                <li class="primary" ng-if="vm.inFrame || vm.review.isManageView">
                    <a class="btn main" ng-click="vm.print()">{{ 'general.Print' | translate }}</a>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($rootScope, $scope, $translate, $window, MomentService, ModalService, REVIEW_STEP_ENUM, REVIEW_STATUS_ENUM) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.$window = $window;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.REVIEW_STEP_ENUM = REVIEW_STEP_ENUM;
        this.REVIEW_STATUS_ENUM = REVIEW_STATUS_ENUM;
        $scope.$on('review:save:success', () => {
            this.error = false;
            this.hideButtons = false;
            this.next();
            this.initInfoSection();
        });
        $scope.$on('review:save:error', (event, error) => {
            this.hideButtons = false;
            this.error = error;
        });
        $scope.$on('review:confirm:success', (event, finalConfirm) => {
            this.finished = true;
            this.error = false;
            this.confirmed = finalConfirm;
        });
        $scope.$on('review:decline:success', () => {
            this.declined = true;
        });
        $scope.$on('review:step:back', () => {
            this.$scope.$broadcast('review:save');
        });
        $rootScope.$on('review:language', (event, language) => this.initInfoSection(language));
    }

    $onInit () {
        this.inFrame = self !== top;
        this.error = false;
        this.finished = false;
        this.declined = false;
        this.step = this.REVIEW_STEP_ENUM.INFO;
        this.hideButtons = false;
        this.initInfoSection();
    }

    print () {
        this.$window.print();
    }

    initInfoSection (language = null) {
        const deadline = this.review.deadline;
        this.answersSaved = {
            text: this.$translate.instant('review.notice.answers_are_saved', language),
            show: !this.review.isManager &&
                this.review.status === this.REVIEW_STATUS_ENUM.KEYS.FILL_EMPLOYEE &&
                !this.MomentService.isPassedDate(deadline) &&
                this.step === this.REVIEW_STEP_ENUM.INFO
        };
        this.answersConfirmed = {
            text: this.$translate.instant(
                'review.alert.answers_confirmed_automatically',
                { deadline: this.MomentService.format(deadline, 'DD.MM.YYYY') }
            ),
            show: !this.review.isManager &&
                this.review.status === this.REVIEW_STATUS_ENUM.KEYS.FILL_EMPLOYEE &&
                !this.MomentService.isPassedDate(deadline) &&
                this.step === this.REVIEW_STEP_ENUM.SUMMARY
        };
    }

    showNextButton () {
        return this.step !== this.REVIEW_STEP_ENUM.SUMMARY && !this.review.isReadOnly && !this.hideButtons;
    }

    showBackButton () {
        return this.step !== this.REVIEW_STEP_ENUM.INFO && !this.review.isReadOnly && !this.hideButtons;
    }

    showSummaryStepButtons () {
        return this.step === this.REVIEW_STEP_ENUM.SUMMARY && !this.review.isReadOnly && !this.hideButtons;
    }

    showConfirmButton () {
        return !this.review.isManageView && !this.review.isManager && this.review.status === this.REVIEW_STATUS_ENUM.KEYS.CONFIRM_EMPLOYEE;
    }

    isFormDeadlinePassed () {
        return this.review.status === this.REVIEW_STATUS_ENUM.KEYS.FILL_MANAGER && this.MomentService.isPassedDate(this.review.deadline);
    }

    save () {
        this.hideButtons = true;
        this.$scope.$broadcast('review:save');
    }

    confirm (finalConfirm = false, review = false) {
        this.hideButtons = true;
        if (review) {
            this.confirmLastStepForEmployee(review);
        }
        else {
            this.$scope.$broadcast('review:confirm', finalConfirm);
        }
    }

    decline (review) {
        return this.ModalService.open({
            template: `
                <modals-review-decline
                    uib-modal-instance="vm.$uibModalInstance"
                    review="vm.review"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.review = review;
            }
        });
    }

    confirmLastStepForEmployee (review = null) {
        return this.ModalService.open({
            template: `
            <modals-review-confirm
                uib-modal-instance="vm.$uibModalInstance"
                review="vm.review"
            />
        `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.review = review;
            }
        });
    }

    back () {
        this.$window.scrollTo(0, 0);
        const { REVIEW_STEP_ENUM } = this;
        switch (this.step) {
        case REVIEW_STEP_ENUM.RESULTS_AND_GOALS:
            this.step = REVIEW_STEP_ENUM.OVERALL_OVERVIEW;
            break;
        case REVIEW_STEP_ENUM.PERSONAL_DEVELOPMENT:
            this.step = REVIEW_STEP_ENUM.RESULTS_AND_GOALS;
            break;
        case REVIEW_STEP_ENUM.FEEDBACK:
            this.step = REVIEW_STEP_ENUM.PERSONAL_DEVELOPMENT;
            break;
        case REVIEW_STEP_ENUM.SUMMARY:
            this.step = REVIEW_STEP_ENUM.FEEDBACK;
            break;
        default:
            this.step = REVIEW_STEP_ENUM.INFO;
        }
        this.$scope.$broadcast('review:step:back');
    }

    next () {
        this.$window.scrollTo(0, 0);
        const { REVIEW_STEP_ENUM } = this;
        switch (this.step) {
        case REVIEW_STEP_ENUM.INFO:
            this.step = REVIEW_STEP_ENUM.OVERALL_OVERVIEW;
            break;
        case REVIEW_STEP_ENUM.OVERALL_OVERVIEW:
            this.step = REVIEW_STEP_ENUM.RESULTS_AND_GOALS;
            break;
        case REVIEW_STEP_ENUM.RESULTS_AND_GOALS:
            this.step = REVIEW_STEP_ENUM.PERSONAL_DEVELOPMENT;
            break;
        case REVIEW_STEP_ENUM.PERSONAL_DEVELOPMENT:
            this.step = REVIEW_STEP_ENUM.FEEDBACK;
            break;
        default:
            this.step = REVIEW_STEP_ENUM.SUMMARY;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/default/index.js